"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _KYC_IMLegacyLevelsComponent = _interopRequireDefault(require("./KYC_IMLegacyLevelsComponent"));
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openKYCSidePane: function openKYCSidePane() {
      return dispatch((0, _sidePaneActions.openKYC_IMLegacySidePane)());
    }
  };
};
var KYC_IMLegacyLevelsContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(_KYC_IMLegacyLevelsComponent["default"]);
var _default = exports["default"] = KYC_IMLegacyLevelsContainer;